export const PRODUCT_STATUS = {
  missingUrgent: "Missing - Urgent",
  missing: "Missing",
  approved: "Approved",
};

export const BadgeType = {
  SUCCESS: "success",
  DANGER: "danger",
  ALARM: "alarm",
};
